import React from "react";
import TitleWithBorder from "../../components/TitleWithBorder";
import ReleasesList from "../../components/ReleasesList";
import PageContainer from "../../components/PageContainer";
import NothingFound from "../../components/NothingFound";
import {
  PodcastsTitleSkeleton,
  ReleasesContainer,
  ReleaseTitleSkeleton,
} from "./styled";
import Skeleton from "react-loading-skeleton";
import {
  useGetPodcastsQuery,
  useGetReleasesQuery,
} from "../../api/podcastsApi";
import PodcastsListSlider from "../../components/PodcastsListSlider";
import { useDispatch } from "react-redux";
import { setReleasePodcastInfo } from "../../redux/Slice/releasePodcastSlice";
import { openModal } from "../../redux/Slice/modalSlice";
import { modalState } from "../../utils/constants";
import { sortByPublishAt } from "../../utils/sortByPublishAt";

export const PodcastsPage = () => {
  const {
    data: releases,
    isError: isReleasesError,
    isLoading: isReleasesLoading,
  } = useGetReleasesQuery();
  const {
    data: podcasts,
    isError: isPodcastsError,
    isLoading: isPodcastsLoading,
  } = useGetPodcastsQuery();

  const isLoading = isPodcastsLoading || isReleasesLoading;

  const dispatch = useDispatch();

  const sortLatestReleases = sortByPublishAt(releases?.latestPodcastReleases);

  const handleClickCardRelease = (release) => {
    dispatch(setReleasePodcastInfo(release));

    dispatch(openModal(modalState.RELEASE_PODCAST_INFO));
  };

  if (isPodcastsError || isReleasesError) {
    return <NothingFound />;
  }

  return (
    <PageContainer>
      {isLoading ? (
        <PodcastsTitleSkeleton as={Skeleton} />
      ) : (
        <TitleWithBorder variant="h2">Подкасты</TitleWithBorder>
      )}
      <PodcastsListSlider
        podcasts={podcasts}
        isLoading={isLoading}
        showProgress
      />
      <ReleasesContainer>
        <div>
          {isLoading ? (
            <ReleaseTitleSkeleton as={Skeleton} />
          ) : (
            <TitleWithBorder variant="h2">Лучшие выпуски</TitleWithBorder>
          )}
          <ReleasesList
            releases={releases?.bestPodcastReleases}
            isLoading={isLoading}
            podcasts={podcasts}
            onClickCardRelease={handleClickCardRelease}
          />
        </div>
        <div>
          {isLoading ? (
            <ReleaseTitleSkeleton as={Skeleton} />
          ) : (
            <TitleWithBorder variant="h2">Последние выпуски</TitleWithBorder>
          )}
          <ReleasesList
            releases={sortLatestReleases}
            isLoading={isLoading}
            podcasts={podcasts}
            onClickCardRelease={handleClickCardRelease}
          />
        </div>
      </ReleasesContainer>
    </PageContainer>
  );
};
